import {createSinglePathSVG} from './TEMPLATE'

/**
 * Open-external mark - a box with an arrow leaving its top-right corner -
 * exported directly from Figma (node 243:3424, file
 * pxYtWNgjV2VOLMGYr0ujlL) for the Insert-link popover's "open this link"
 * action, at the project owner's request.
 *
 * Not `ArrowShareRight.tsx`, which shares the "share" idea but is a
 * different glyph: a solid, filled forward arrow with no box. Same reason
 * `MenuItemCheck` exists alongside the generic check.
 */
export const Share04 = createSinglePathSVG({
  path: 'M12.5 2.5H17.5L17.5 7.5M17.5 2.5L10.8333 9.16667M8.33333 4.16667H6.5C5.09987 4.16667 4.3998 4.16667 3.86502 4.43915C3.39462 4.67883 3.01217 5.06129 2.77248 5.53169C2.5 6.06647 2.5 6.76654 2.5 8.16667V13.5C2.5 14.9001 2.5 15.6002 2.77248 16.135C3.01217 16.6054 3.39462 16.9878 3.86502 17.2275C4.3998 17.5 5.09987 17.5 6.5 17.5H11.8333C13.2335 17.5 13.9335 17.5 14.4683 17.2275C14.9387 16.9878 15.3212 16.6054 15.5608 16.135C15.8333 15.6002 15.8333 14.9001 15.8333 13.5V11.6667',
  viewBox: '0 0 20 20',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
})
